import React from "react";
import { Grid, Box, Typography, useTheme } from "@mui/material";

type AuthLayoutProps = {
    children: React.ReactNode;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    const theme = useTheme();

    return (
        <Grid
            container
            style={{
                backgroundColor: theme.palette.background.default,
                minHeight: "100vh",
                width: "100vw",
            }}
            justifyContent="center"
            alignItems="center"
        >
            <Grid item xs={12} style={{ width: "100%" }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: theme.palette.primary.main,
                        padding: 2,
                        fontSize: 32,
                    }}
                >
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontFamily: '"Noto Serif JP", serif',
                            fontSize: "32px",
                            fontStyle: "normal",
                            fontWeight: 800,
                            letterSpacing: "3.2px",
                        }}
                    >
                        OWReport
                    </Typography>
                </Box>
                {children}
            </Grid>
        </Grid>
    );
};

export default AuthLayout;
